import { __decorate, __awaiter } from 'tslib';
import { ɵɵdefineInjectable, Injectable, Input, Component, NgModule } from '@angular/core';

import * as ɵngcc0 from '@angular/core';
let ChangelogfyService = class ChangelogfyService {
    constructor() { }
};
ChangelogfyService.ɵfac = function ChangelogfyService_Factory(t) { return new (t || ChangelogfyService)(); };
ChangelogfyService.ɵprov = ɵɵdefineInjectable({ factory: function ChangelogfyService_Factory() { return new ChangelogfyService(); }, token: ChangelogfyService, providedIn: "root" });

let ChangelogfyComponent = class ChangelogfyComponent {
    constructor() {
        this.initBadge = true;
        this.userId = null;
        this.userName = null;
        this.userEmail = null;
        this.isFollowing = true;
        this.customData = null;
        this.scriptIsLoaded = false;
    }
    ngOnInit() { }
    ngAfterViewInit() {
        this.start();
    }
    loadScript() {
        return new Promise((resolve, reject) => {
            const script = document.createElement('script');
            script.src = 'https://widget.changelogfy.com/index.js';
            script.id = 'changelogfy-script';
            script.type = 'text/javascript';
            script.async = true;
            document.head.appendChild(script);
            script.addEventListener('load', () => {
                this.scriptIsLoaded = true;
                resolve(script);
            });
            script.addEventListener('error', () => {
                reject(new Error(`Changelogfy failed to load.`));
            });
        });
    }
    start() {
        return __awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
                try {
                    if (!this.scriptIsLoaded) {
                        yield this.loadScript();
                    }
                    resolve();
                    // @ts-ignore
                    changelogfy.destroy();
                    // @ts-ignore
                    changelogfy.init({
                        app_id: this.appId,
                        selector: this.selector,
                        init_badge: this.initBadge,
                        data: {
                            user_id: this.userId,
                            user_name: this.userName,
                            user_email: this.userEmail,
                            is_following: this.isFollowing,
                            custom_data: this.customData,
                        },
                    });
                }
                catch (e) {
                    reject(e);
                }
            }));
        });
    }
};
ChangelogfyComponent.ɵfac = function ChangelogfyComponent_Factory(t) { return new (t || ChangelogfyComponent)(); };
ChangelogfyComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: ChangelogfyComponent, selectors: [["lib-changelogfy"]], inputs: { initBadge: "initBadge", userId: "userId", userName: "userName", userEmail: "userEmail", isFollowing: "isFollowing", customData: "customData", appId: "appId", selector: "selector" }, decls: 1, vars: 0, template: function ChangelogfyComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelement(0, "span");
    } }, encapsulation: 2 });
__decorate([
    Input()
], ChangelogfyComponent.prototype, "appId", void 0);
__decorate([
    Input()
], ChangelogfyComponent.prototype, "selector", void 0);
__decorate([
    Input()
], ChangelogfyComponent.prototype, "initBadge", void 0);
__decorate([
    Input()
], ChangelogfyComponent.prototype, "userId", void 0);
__decorate([
    Input()
], ChangelogfyComponent.prototype, "userName", void 0);
__decorate([
    Input()
], ChangelogfyComponent.prototype, "userEmail", void 0);
__decorate([
    Input()
], ChangelogfyComponent.prototype, "isFollowing", void 0);
__decorate([
    Input()
], ChangelogfyComponent.prototype, "customData", void 0);

let ChangelogfyModule = class ChangelogfyModule {
};
ChangelogfyModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: ChangelogfyModule });
ChangelogfyModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function ChangelogfyModule_Factory(t) { return new (t || ChangelogfyModule)(); }, imports: [[]] });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ChangelogfyService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ChangelogfyComponent, [{
        type: Component,
        args: [{
                selector: 'lib-changelogfy',
                template: `<span></span>`
            }]
    }], function () { return []; }, { initBadge: [{
            type: Input
        }], userId: [{
            type: Input
        }], userName: [{
            type: Input
        }], userEmail: [{
            type: Input
        }], isFollowing: [{
            type: Input
        }], customData: [{
            type: Input
        }], appId: [{
            type: Input
        }], selector: [{
            type: Input
        }] }); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(ChangelogfyModule, { declarations: [ChangelogfyComponent], exports: [ChangelogfyComponent] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ChangelogfyModule, [{
        type: NgModule,
        args: [{
                declarations: [ChangelogfyComponent],
                imports: [],
                exports: [ChangelogfyComponent]
            }]
    }], null, null); })();

/*
 * Public API Surface of changelogfy
 */

/**
 * Generated bundle index. Do not edit.
 */

export { ChangelogfyComponent, ChangelogfyModule, ChangelogfyService };

//# sourceMappingURL=changelogfy-angular.js.map